/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSquareRoot = createReactComponent("square-root", "IconSquareRoot", [
  ["path", { d: "M3 12h2l4 8l4 -16h8", key: "svg-0" }]
]);

export { IconSquareRoot as default };
//# sourceMappingURL=IconSquareRoot.js.map
